import { AspectRatio, Box, Flex, Grid } from '@hover/blueprint';
import React, { useState } from 'react';

import {
  Selector,
  SelectorItem,
} from 'src/modules/homeownerApp/components/Selector';
import { hideScrollbars } from 'src/shared/helpers/styles';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';

import { SampleImage, styles } from './SampleImage';
import { Switch } from './Switch';
import { TryItCard } from './TryItCard';

const HiddenScrollBox = hideScrollbars(Box);

const ImageGrid = () => {
  const [style, setStyle] = useState<string | undefined>(undefined);
  const [isBeforeSelected, setIsBeforeSelected] = useState(false);
  const t = useTranslate(TranslationNamespace.HOMEOWNER_APP);

  return (
    <>
      <HiddenScrollBox
        height={400}
        overflowX="scroll"
        overflowY="hidden"
        position="sticky"
        width="100%"
      >
        <Selector
          defaultValue={undefined}
          height="100%"
          justifyContent="start"
          onChange={newStyle => {
            setStyle(newStyle === 'All Styles' ? undefined : newStyle);
            setIsBeforeSelected(false);
          }}
          value={style || 'All Styles'}
          variant="secondary"
        >
          <SelectorItem value="All Styles">{t('pro.allStyles')}</SelectorItem>
          {styles.map(styleItem => (
            <SelectorItem key={styleItem} value={styleItem ?? undefined}>
              {styleItem}
            </SelectorItem>
          ))}
        </Selector>
      </HiddenScrollBox>
      <Box padding={{ base: 500, tablet: 800 }} width="100%">
        <Grid
          flexDirection={{ base: 'column', tablet: 'row' }}
          gridGap={500}
          gridTemplateColumns={{ base: '1fr', tablet: '1.15fr 1fr 1fr 1fr' }}
          gridTemplateRows={{ base: 'auto', tablet: '1fr 1fr' }}
          width="100%"
        >
          <Flex
            gridColumn={{ base: '1', tablet: 'span 2' }}
            gridRow={{ base: '1', tablet: 'span 2' }}
            position="relative"
            width="100%"
          >
            <SampleImage
              isBeforeSelected={isBeforeSelected}
              spaceType="Exterior"
              styleName={style || 'Traditional'}
            />
            <Box
              bottom={1000}
              display={{ base: 'none', tablet: 'flex' }}
              height="50px"
              justifyContent="center"
              left="0"
              position="absolute"
              right="0"
            >
              <Switch
                handleClick={() => setIsBeforeSelected(!isBeforeSelected)}
                isOn={!isBeforeSelected}
                offText={t('pro.before')}
                onText={t('pro.after')}
              />
            </Box>
          </Flex>
          <Box
            gridColumn={{ base: '1', tablet: '3 / span 2' }}
            gridRow={{ base: '2', tablet: '1' }}
            width="100%"
          >
            <SampleImage
              isBeforeSelected={isBeforeSelected}
              marginRight={{ base: 100, tablet: 500 }}
              spaceType="Exterior"
              styleName={style || 'Mediterranean'}
              width="50%"
            />
            <SampleImage
              isBeforeSelected={isBeforeSelected}
              spaceType="Interior"
              styleName={style || 'Coastal'}
              width="50%"
            />
          </Box>
          <Box
            gridColumn={{ base: '1', tablet: '3' }}
            gridRow={{ base: '4', tablet: '2' }}
            width="100%"
          >
            <SampleImage
              isBeforeSelected={isBeforeSelected}
              spaceType="Interior"
              styleName={style || 'Contemporary'}
            />
          </Box>
          <AspectRatio
            gridColumn={{ base: '1', tablet: '4' }}
            gridRow={{ base: '5', tablet: '2' }}
            ratio={3 / 4}
            width="100%"
          >
            <Box pb="60px" width="100%">
              <TryItCard />
            </Box>
          </AspectRatio>
        </Grid>
      </Box>
    </>
  );
};

export { ImageGrid };
